/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
/**
 * Interface containing the max canvas limit data
 */
export interface ICanvasLimits {
	maxWidth: number;
	maxHeight: number;
	maxArea: number;
}

/**
 * There are hard limits on the size of a <canvas> HTML element, depending on the browser:
 * Chrome has a maximum width/height of 32,767 pixels and an area of 268,435,456 pixels.
 * 	Effective limit is therefore 16384x16384
 * Firefox has a maximum width/height of 32,767 pixels and an area of 472,907,776 pixels.
 * 	Effective limit is therefore: 22,528 x 20,992 pixels.
 */
export const maxCanvasSize: ICanvasLimits = {
	maxWidth: 16384,
	maxHeight: 16384,
	maxArea: 268435456,
};
